import React from 'react';
import { EllipsisToXIcon } from '@repo/icons/EllipsisToXIcon';
import { SmallUppercaseText } from '@repo/components/typography';

export const BrowserExtensionMoreOptionsTrigger = (props: { isOpen?: boolean }) => (
  <>
    <EllipsisToXIcon isOpen={!!props.isOpen} hoverOpacity={false} color="textPrimary" />
    <SmallUppercaseText>More</SmallUppercaseText>
  </>
);
